export const ALL_ROLES = [
  "Super Admin",
  "Management / Owner",
  "Accountant",
  "Warehouse Manager",
  "Warehouse Operator",
  "Inward Operator",
  "Outward Operator",
  "Stack Supervisor",
  "Labour Supervisor",
];

const ADMIN = ["Super Admin", "Management / Owner"];
const FINANCE = [...ADMIN, "Accountant"];
const MASTERS = [...FINANCE, "Warehouse Manager"];
const STOCK_OPS = [...MASTERS, "Warehouse Operator"];

/** Pages each role may open. Super Admin always passes canAccessPage(). */
export const PAGE_ROLES = {
  "/": ALL_ROLES,
  "/inward": [...STOCK_OPS, "Inward Operator"],
  "/outward": [...STOCK_OPS, "Outward Operator"],
  "/transfer": [...STOCK_OPS, "Stack Supervisor"],
  "/stacks": ALL_ROLES,
  "/lots": ALL_ROLES,
  "/parties": MASTERS,
  "/rent": FINANCE,
  "/payments": FINANCE,
  "/cash": [...FINANCE, "Warehouse Manager"],
  "/registers": ALL_ROLES,
  "/onboard": MASTERS,
  "/masters": MASTERS,
};

export function canAccessPage(role, path) {
  if (!role) return false;
  if (role === "Super Admin") return true;
  const allowed = PAGE_ROLES[path];
  if (!allowed) return false;
  return allowed.includes(role);
}

export function canManageUsers(role) {
  return role === "Super Admin" || role === "Management / Owner";
}
